import { AutogenModelStopLookup, AutogenRowStopLookup } from "./autogen/AutogenModelStopLookup";

export class ModelStopLookup extends AutogenModelStopLookup<RowStopLookup> {
	constructor() {
		super(RowStopLookup);
	}
}

export class RowStopLookup extends AutogenRowStopLookup {
}